import { SCRAPE_BENCHMARK } from '../../../data/scrapeBenchmark';
import { m } from '../../../paraglide/messages';

/** The launch video in a tinted frame, so its white frames never sit on the
 *  dark page as a bare white rectangle. Poster first; nothing is fetched until
 *  it is played. */
export const ScrapeRouterVideo = ({ className = '' }: { className?: string }) => {
  const { src, poster, width, height } = SCRAPE_BENCHMARK.video;
  return (
    <div className={`rounded-20 border border-rule bg-surface-3 p-1.5 shadow-[var(--card-shadow)] s620:p-2 ${className}`}>
      <video
        src={src}
        poster={poster}
        width={width}
        height={height}
        aria-label={m.scrape_router_video()}
        muted
        playsInline
        controls
        loop
        preload="none"
        className="block aspect-video h-auto w-full rounded-14 bg-surface [[data-theme=dark]_&]:brightness-90"
      />
    </div>
  );
};
